import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { INotificationUserTable, ITarget } from '../../types/interfaces';
import { getNotificationImage } from '../../flux/actions/notificationmodelActions';

// import NotificationEdit from './NotificationEdit';
import NotificationDelete from './NotificationDelete';
import TableContainer from "../tables_manager/TableContainer"
import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faCheckCircle, faClipboard, faExternalLinkAlt, faEye, faEyeSlash, faIdCard, faImage, faList, faPen, faPhone, faPrint, faTimesCircle, faTrash, faUsers } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import Loading from '../Loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';
import { beautifyName } from '../../services/misc';
import NotificationTable from './NotificationTable';

const NotificationUserTable = ({ 
  linesData,
  setTableData,
  notification_models
 }: INotificationUserTable) => {
  const [modalN, setModalN] = useState(false);
  const [modalNData, setModalNData] = useState<any>(undefined);
  const [modalLines, setModalLines] = useState<any[]>([]);
  
  const handleToggleN = () => setModalN(!modalN);

  const modalOpenedHandle = () => {
    if(modalNData)
      setModalLines((notification_models || []).filter(n => n.type === modalNData.type && n.notifications?.find(s => s.userId === modalNData.userId)))
    else
      setModalLines([])
  };

  const modalClosedHandle = () => {
    setModalLines([])
  };

  const columns = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: e => (e.user && beautifyName(e.user.given_name, e.user.surname)) || "",
        Cell: ({ value }) => value || "-"
      },
      ...constants.NOTIFICATION_TYPES.map(t => ({
        Header: `Nombre de [${t.label}]`,
        accessor: e => Number(e[`type_${t.code}`] || 0),
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({value, row: {original}}) => <div className="fullFlexCenter" style={{gap: "8px"}}>{value}<FontAwesomeIcon icon={faList} style={{cursor: "pointer"}} onClick={() => {setModalNData({userId: original.user?.id, type: t.code}); setModalN(true)}} /></div>
      })),
    ],
    []
  );

  return (
    <div>
      <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      
      <Modal isOpen={modalN} toggle={handleToggleN} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-extra-large">
        <ModalHeader toggle={handleToggleN}><FontAwesomeIcon icon={faBell} />&nbsp;&nbsp;Notifications</ModalHeader>
        <ModalBody>
          <NotificationTable linesData={modalLines} setTableData={setModalLines} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default connect(null, {})(NotificationUserTable);
